import React from "react";

export default function LoadingSpinner({
  className = "",
  fullScreen = true,
  text = "Loading...",
  logo = "/logo.png",
  platformName = "Your Platform",
}) {
  const splash = (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      {/* Glowing Logo */}
      <div className="relative mb-8 flex items-center justify-center">
        {/* Outer Glow */}
        <div className="absolute h-36 w-36 rounded-full bg-blue-500/20 blur-3xl animate-pulse" />

        {/* Inner Glow */}
        <div className="absolute h-28 w-28 rounded-full bg-cyan-400/20 blur-2xl animate-ping opacity-40" />

        {/* Logo */}
        <img
          src={logo}
          alt={platformName}
          className="relative h-24 w-24 object-contain drop-shadow-[0_0_35px_rgba(59,130,246,0.9)] animate-[pulse_2.5s_ease-in-out_infinite]"
        />
      </div>

      {/* Platform Name */}
      <h1 className="text-3xl font-bold tracking-wide text-white">
        {platformName}
      </h1>

      {/* Loading Text */}
      <p className="mt-3 text-sm text-gray-400">{text}</p>

      {/* Animated Progress Bar */}
      <div className="mt-8 h-1 w-56 overflow-hidden rounded-full bg-white/10">
        <div className="h-full w-1/2 rounded-full bg-gradient-to-r from-blue-500 via-cyan-400 to-blue-500 animate-[loading_1.8s_ease-in-out_infinite]" />
      </div>

      {/* Loading Dots */}
      <div className="mt-5 flex gap-2">
        <span className="h-2 w-2 rounded-full bg-blue-400 animate-bounce [animation-delay:-0.3s]" />
        <span className="h-2 w-2 rounded-full bg-blue-400 animate-bounce [animation-delay:-0.15s]" />
        <span className="h-2 w-2 rounded-full bg-blue-400 animate-bounce" />
      </div>

      {/* Custom Animation */}
      <style>{`
        @keyframes loading {
          0% {
            transform: translateX(-120%);
          }
          50% {
            transform: translateX(40%);
          }
          100% {
            transform: translateX(220%);
          }
        }
      `}</style>
    </div>
  );

  if (fullScreen) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-[#05070d] via-[#09090b] to-[#111827]">
        {splash}
      </div>
    );
  }

  return splash;
}
